export default __webpack_public_path__ + "static/media/gitlab.f0cb7e5f.svg";